import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'
import {
  WaitScreenWrapper,
  ProgressBar,
} from 'src/components/wait-screen'

const AiLoading = props => {
  const { progress } = props

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          maxWidth: '330px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/assets/new_mascot_noline_1.gif"
          height={200}
          style={{ margin: '0 auto' }}
        ></img>
        <Box m={0.5}></Box>
        <ProgressBar progress={progress} />
        <Box m={1}></Box>
        <WaitScreenWrapper
          slides={[
            {
              title: 'Mastering Advanced UI/UX Design Systems',
              description: 'We are crafting your curriculum and gathering the best examples.',
            },
          ]}
          style={{
            width: '100%',
            maxWidth: '960px',
          }}
        />
        <Box m={0.5}></Box>
        <Typography variant="h4" color="primary">
          AI Assistant is in action!
        </Typography>
        <Typography variant="subtitle" style={{ paddingBottom: '10px' }}>
        Great things take time… and it's almost done!
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(AiLoading)
